module.exports = function viewport(app) {
  window.onresize = function () {
    app.ports.viewport.send({
      width: window.innerWidth,
      height: window.innerHeight,
      isFullscreen: !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
    });
  };
};
